
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('user', ['sendPasswordReset']),

    async sendPasswordReset() {
      try {
        const result = await this.sendPasswordReset(this.$auth.user.email)

        this.$toast.success(result.data)
      } catch (e) {}
    },
  },
}
